import _ from "lodash";

function convertMasterActivityToLevelActivityModel(data, levelId) {
  let levelActivity = {
    ActivityId: data.activityId,
    ActivityCode: data.activityCode,
    Description: data.description,
    LevelId: levelId
  };
  return levelActivity;
}

function convertListMasterActivityToLevelActivityModel(data, levelId) {
  let listActivity = [];
  _.forEach(data, function(item) {
    listActivity.push(convertMasterActivityToLevelActivityModel(item, levelId));
  });
  return listActivity;
}

function convertLevelActivityRawModel(data, levelId) {
  let levelActivity = {
    activityCode: data.ActivityCode,
    activityId: data.ActivityId,
    programLevelId: levelId,
    programLevelDescription: data.Description
  };
  if (data.Id) {
    levelActivity.id = data.Id;
  }
  return levelActivity;
}

function convertListLevelActivityRawModel(data, levelId) {
  let listActivity = [];
  if (data && data.length > 0) {
    _.forEach(data, function(item) {
      listActivity.push(convertLevelActivityRawModel(item, levelId));
    });
  }
  return listActivity;
}

export default {
  convertMasterActivityToLevelActivityModel,
  convertListMasterActivityToLevelActivityModel,
  convertListLevelActivityRawModel
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_level_activities/transform.js